export default __webpack_public_path__ + "static/media/1761.d6297e95.png";